import styled from "styled-components";

export const AboutUsComp = styled.div`
    display: flex;
    margin: 3% 5%;
    @media (max-width: 1000px) {
        margin: 5% 2%;
    }

`;

export const AboutUsContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;

`;

export const TextContent = styled.div`
    color: var(--purple-bhbusmidia);
    text-align: center;
    display: flex;
    width: 100%;
    justify-content: space-between;
    background-color: #15191a;
    border-radius: 2em;
    padding: 64px;
    @media (max-width: 1000px) {
        padding: 10px;
        flex-direction: column;
    }
`;

export const ContactDiv = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    h1 {
        font-size: 36px;
        color: #cccccc;
        font-family: 'Montserrat', sans-serif;;
    }
    h2 {
        font-weight: normal;
        font-family: 'Montserrat', sans-serif;
        font-size: 21px;
        color: #cccccc;
    }

    .contato {
        :hover {
            color: var(--orange);
            cursor: pointer;
        }
    }
`;

export const PhotoDiv = styled.div`
    width: 108px;
    height: 108px;
    border-radius: 100%;
    padding: 4px;
    background-image: linear-gradient(135deg, #f5bb12, #ec6b1b);
`;

export const Photo = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 100%;
    object-fit: cover;
`;

export const TextTitle = styled.div`
    text-align: left;
    line-height: 1.5rem;
    margin-top: 3%;
    font-weight: bold;
    font-family: 'Montserrat', sans-serif;;
    h1 {
        font-size: 2rem;
        font-weight: bold;
        color: #cccccc;
        font-family: 'Montserrat', sans-serif;;
    }
    h2 {
        font-weight: normal;
        font-weight: bold;
        font-family: 'Montserrat', sans-serif;
        font-size: 1rem;
        color: #cccccc;
    }
     @media (max-width: 1000px) {
        margin-top: 5%;
        h1 {
            font-size: 1.8rem;
        }
    }

    .contato {
        :hover {
            color: var(--orange);
            cursor: pointer;
        }
    }
`;

export const TextBody = styled.div`
    font-size: 24px;
    width: 100%;
    p {
        margin-top: 3%;
    }
`;

export const VideoContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5%;
`;

export const NavMenu = styled.div`
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 16px;
    margin: 0% 2%;
    color: var(--purple);
    font-weight: bold;
`;

export const NavUl = styled.ul``;

export const NavList = styled.p`
    padding: 5px;
`;


export const SearchDiv = styled.div``;

export const DoubleInput = styled.div`
    display: flex;
    justify-content: center;
    @media (max-width: 1000px) {
        flex-direction: column;
    }
`;